export const menu_theme_configuration = {
  root: {},
  colorScheme: {
    light: { background: "#fff" },
    dark: { background: "#010622" },
  },
};
